// extracted by mini-css-extract-plugin
module.exports = {"listItem":"GripNotificationModal_listItem_1l_Zn","closeIcon":"GripNotificationModal_closeIcon_2gkrw","spinAround":"GripNotificationModal_spinAround_1ivFs"};